import { twJoin } from 'tailwind-merge';

import type { DateTimeInputProps } from './date-time-input';
import { DateTimeInput } from './date-time-input';

import { FormControl, FormItem, FormMessage } from '../form';

type Props = DateTimeInputProps & {
  formItemClassName?: string;
};

export function FormDateTimeInput({ formItemClassName, ...rest }: Props) {
  return (
    <FormItem className={twJoin(formItemClassName, '[&>.react-datepicker-wrapper]:block')}>
      <FormControl>
        <DateTimeInput {...rest} />
      </FormControl>
      <FormMessage />
    </FormItem>
  );
}
